// ============================================================================
// BonBoZ: định dạng NGÀY THÁNG cho trang Thống kê và ô chọn khoảng ngày.
//
// VÌ SAO KHÔNG CHỈ TRUYỀN LOCALE VÀO date-fns: `format(d, 'MMM')` với locale
// tiếng Việt trả về "thg 8" — dài hơn tiếng Anh, và trên vạch trục biểu đồ thì
// "18-thg 8" vừa rối vừa tràn. Tiếng Việt vốn viết ngày bằng SỐ ("18/08"), nên
// đúng cách là đổi hẳn khuôn dạng chứ không dịch tên tháng.
//
// Upstream viết cứng khuôn Mỹ ở nhiều chỗ: `MMM d, yyyy` trên nút chọn khoảng
// ngày, `dd-MMM` trên trục X mọi biểu đồ, `h:mm a` (SA/CH) trong bảng chi tiết.
// ============================================================================
import { format } from 'date-fns';

const laViet = () =>
  typeof document !== 'undefined' &&
  Boolean(document.documentElement.lang?.startsWith('vi'));

// Mỗi khuôn một cặp: tiếng Việt dùng số, tiếng Anh giữ nguyên bản gốc để
// chuyển ngôn ngữ vẫn ra đúng thứ upstream vẫn hiển thị.
const KHUON = {
  ngayThang: { vi: 'dd/MM', en: 'dd-MMM' }, // vạch trục X
  thangNam: { vi: 'MM/yyyy', en: 'MMM-yyyy' }, // trục X khi gộp theo tháng
  ngayDay: { vi: 'd/M/yyyy', en: 'MMM d, yyyy' }, // nút chọn khoảng ngày, nhãn bản đồ nhiệt
  ngayNgan: { vi: 'd/M', en: 'MMM d' }, // đầu khoảng khi cùng năm
  ngayGio: { vi: 'dd/MM/yyyy HH:mm', en: 'dd MMM yyyy, h:mm a' }, // bảng chi tiết
};

/**
 * @param {Date|number} ngay
 * @param {keyof KHUON} ten - tên khuôn dạng, xem bảng KHUON.
 */
export function ngay(ngayCanDinhDang, ten) {
  const k = KHUON[ten];
  return format(ngayCanDinhDang, laViet() ? k.vi : k.en);
}

// Bảy chữ cái đầu hàng trong lịch. Upstream viết cứng ['M','T','W','T','F','S','S'] —
// tiếng Việt là T2..T7 + CN, và CHỦ NHẬT ĐỨNG ĐẦU hay đứng cuối là do lịch
// dựng theo `getDay()` (0 = chủ nhật), nên phải khớp đúng thứ tự đó.
const DAU_THU = {
  vi: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
  en: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
};

/**
 * @param {boolean} [batDauChuNhat=true] - lịch bắt đầu từ chủ nhật.
 * @returns {string[]} 7 nhãn cột, theo đúng thứ tự lịch đang dựng.
 */
export function dauThu(batDauChuNhat = true) {
  const b = laViet() ? DAU_THU.vi : DAU_THU.en;
  return batDauChuNhat ? b : [...b.slice(1), b[0]];
}

/**
 * Tên tháng ở đầu lịch: "Tháng 8 2026" thay vì "August".
 */
export function tenThang(ngayCanDinhDang) {
  return laViet()
    ? `Tháng ${format(ngayCanDinhDang, 'M')}`
    : format(ngayCanDinhDang, 'MMMM');
}
